module.exports = __webpack_public_path__ + "img/zc.bfad2154.png";